import Dexie from 'dexie';

export const dbAppOffline = new Dexie('Siis');

dbAppOffline.version(1).stores({
  actuaciones: '++id',
});

export default dbAppOffline;